(function () {
  'use strict';

  if (window.GPUsedBackToTopReady) return;
  window.GPUsedBackToTopReady = true;

  var BUTTON_SELECTOR = '[data-gp-back-to-top]';
  var BLOCKING_SELECTOR = [
    '#gpused-assistant.gpused-assistant--open',
    'cart-drawer.active',
    'pickup-availability-drawer[open]',
    'modal-dialog[open]',
    'header-drawer > details[open]',
    'details-modal details[open]',
    '.mobile-facets__wrapper > details[open]',
    '[role="dialog"][aria-modal="true"]',
    '[role="alertdialog"]'
  ].join(', ');
  var BOTTOM_OBSTRUCTION_SELECTOR = [
    '#shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '[data-shopify-privacy-banner]',
    'cart-notification .cart-notification.active',
    '[data-gpused-sticky-atc][aria-hidden="false"]'
  ].join(', ');
  var WATCH_SELECTOR = [
    '#gpused-assistant',
    'cart-drawer',
    'pickup-availability-drawer',
    'modal-dialog',
    'header-drawer > details',
    'details-modal details',
    '.mobile-facets__wrapper > details',
    '[role="dialog"]',
    '[role="alertdialog"]',
    '#shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '[data-shopify-privacy-banner]',
    'cart-notification .cart-notification',
    '[data-gpused-sticky-atc]'
  ].join(', ');

  var button = null;
  var frameId = null;

  function isVisible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isPrivacySurface(element) {
    return Boolean(
      element &&
      element.closest(
        '#shopify-pc__banner, .shopify-pc__banner__dialog, [data-shopify-privacy-banner]'
      )
    );
  }

  function hasBlockingSurface() {
    var surfaces = document.querySelectorAll(BLOCKING_SELECTOR);

    for (var index = 0; index < surfaces.length; index += 1) {
      if (!isPrivacySurface(surfaces[index]) && isVisible(surfaces[index])) return true;
    }

    return false;
  }

  function baseOffset() {
    return window.matchMedia('(max-width: 749px)').matches ? 12 : 16;
  }

  function updateBottomOffset() {
    if (!button || button.hidden) return;

    var viewportHeight = window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;
    var offset = baseOffset();
    var gap = 12;
    var buttonLeft = button.getBoundingClientRect().left;
    var buttonRight = buttonLeft + Math.max(button.offsetWidth, 44);
    var obstructions = document.querySelectorAll(BOTTOM_OBSTRUCTION_SELECTOR);

    for (var index = 0; index < obstructions.length; index += 1) {
      var element = obstructions[index];
      if (!isVisible(element)) continue;

      var style = window.getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') continue;

      var rect = element.getBoundingClientRect();
      var overlapsHorizontally = rect.left < buttonRight && rect.right > buttonLeft;
      var reachesViewportBottom = rect.bottom >= viewportHeight - 2;

      if (overlapsHorizontally && reachesViewportBottom) {
        offset = Math.max(offset, Math.ceil(viewportHeight - rect.top + gap));
      }
    }

    document.documentElement.style.setProperty(
      '--gp-back-to-top-bottom',
      'calc(' + offset + 'px + env(safe-area-inset-bottom, 0px))'
    );
  }

  function bindButton(nextButton) {
    if (!nextButton || nextButton.dataset.gpBackToTopReady === 'true') return;

    nextButton.dataset.gpBackToTopReady = 'true';
    nextButton.addEventListener('click', function () {
      var focusTarget = document.querySelector('.header__heading-link');
      if (focusTarget && typeof focusTarget.focus === 'function') {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch (error) {
          focusTarget.focus();
        }
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  function reconcile() {
    var nextButton = document.querySelector(BUTTON_SELECTOR);
    if (nextButton !== button) {
      button = nextButton;
      bindButton(button);
    }
    if (!button) return;

    var threshold = Math.max(480, window.innerHeight * 0.75);
    var shouldShow = window.scrollY > threshold && !hasBlockingSurface();
    if (button.hidden === shouldShow) button.hidden = !shouldShow;

    if (shouldShow) updateBottomOffset();
  }

  function queueReconcile() {
    if (frameId !== null) return;

    frameId = window.requestAnimationFrame(function () {
      frameId = null;
      reconcile();
    });
  }

  function init() {
    reconcile();
    window.addEventListener('scroll', queueReconcile, { passive: true });
    window.addEventListener('resize', queueReconcile, { passive: true });
    document.addEventListener('shopify:section:load', queueReconcile);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', queueReconcile, { passive: true });
    }

    if (window.MutationObserver && document.body) {
      var watchedSurfaces = new WeakSet();
      var surfaceObserver = new MutationObserver(queueReconcile);

      function observeKnownSurfaces() {
        var surfaces = document.querySelectorAll(WATCH_SELECTOR);
        for (var index = 0; index < surfaces.length; index += 1) {
          if (watchedSurfaces.has(surfaces[index])) continue;
          watchedSurfaces.add(surfaces[index]);
          surfaceObserver.observe(surfaces[index], {
            attributes: true,
            attributeFilter: ['aria-hidden', 'aria-modal', 'class', 'hidden', 'open', 'style']
          });
        }
      }

      var bodyObserver = new MutationObserver(function () {
        observeKnownSurfaces();
        queueReconcile();
      });
      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      observeKnownSurfaces();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
